import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "bg-ff table-content" }
const _hoisted_2 = {
  key: 0,
  class: "flex top-button-group"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "c-ff" }, "新增门店", -1)
const _hoisted_4 = {
  class: "flex",
  style: {"align-items":"center","justify-content":"center"}
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode("设置")
const _hoisted_6 = { style: {"margin-left":"10px"} }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("角色管理")
const _hoisted_8 = { style: {"margin-left":"10px"} }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("员工管理")
const _hoisted_10 = { style: {"margin-left":"10px"} }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("下载收款码")
const _hoisted_12 = { class: "flex flexR mar-t-22" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.user.store_id == 0)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode(_component_el_button, {
            class: "bg-red",
            onClick: _ctx.addShop
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }, 8, ["onClick"])
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", null, [
      _withDirectives(_createVNode(_component_el_table, {
        data: _ctx.tableData,
        stripe: "",
        style: {"width":"100%"},
        class: "table",
        "header-cell-style": _ctx.headClass
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.columnList, (item, index) => {
            return (_openBlock(), _createBlock(_component_el_table_column, {
              align: "center",
              prop: item.prop,
              label: item.label,
              "min-width": item.width,
              key: index
            }, null, 8, ["prop", "label", "min-width"]))
          }), 128)),
          _createVNode(_component_el_table_column, {
            label: "操作",
            align: "center",
            "min-width": "200"
          }, {
            default: _withCtx((scope) => [
              _createVNode("div", _hoisted_4, [
                _createVNode("div", null, [
                  (_ctx.roleList.set)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 0,
                        class: "btn",
                        onClick: ($event: any) => (
                                        _ctx.toEdit(scope.row.id)
                                    )
                      }, {
                        default: _withCtx(() => [
                          _hoisted_5
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true)
                ]),
                _createVNode("div", _hoisted_6, [
                  (_ctx.roleList.role_set)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 0,
                        class: "btn",
                        onClick: ($event: any) => (_ctx.toRole(scope.row.id))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_7
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true)
                ]),
                _createVNode("div", _hoisted_8, [
                  (_ctx.roleList.staff_set)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 0,
                        class: "btn",
                        onClick: ($event: any) => (_ctx.toStaff(scope.row.id))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_9
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true)
                ]),
                _createVNode("div", _hoisted_10, [
                  (_ctx.roleList.download)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 0,
                        class: "btn",
                        onClick: ($event: any) => (_ctx.downLoadQrcode(scope.row.id))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_11
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data", "header-cell-style"]), [
        [_directive_loading, _ctx.loading]
      ])
    ]),
    _createVNode("div", _hoisted_12, [
      _createVNode(_component_el_pagination, {
        onSizeChange: _ctx.handleSizeChange,
        onCurrentChange: _ctx.handleCurrentChange,
        "current-page": _ctx.currentPage,
        "page-sizes": [10, 20,50,100],
        "page-size": _ctx.pageSize,
        layout: "total, sizes, prev, pager, next, jumper",
        total: _ctx.total
      }, null, 8, ["onSizeChange", "onCurrentChange", "current-page", "page-size", "total"])
    ])
  ]))
}